import { jsx } from "react/jsx-runtime";
export default function SvgIcon(props) {
  return /* @__PURE__ */ jsx("svg", { ...props, width: "8", height: "8", viewBox: "0 0 8 8", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ jsx("path", { id: "Ellipse 1100", d: "M8 4C8 6.20914 6.20914 8 4 8C1.79086 8 0 6.20914 0 4C0 1.79086 1.79086 0 4 0C6.20914 0 8 1.79086 8 4Z", fill: "#2F9469" }) });
}
